// extracted by mini-css-extract-plugin
module.exports = {"root":"IconButton_root__38JZz","default":"IconButton_default__3tXuV","error":"IconButton_error__1XeUi","warning":"IconButton_warning__vmXqd"};